import { Button, Modal, Select, Stack } from "@mantine/core";
import { useState } from "react";
import { useParameterSetCollection } from "../../../../../hooks/useParameterSetCollection";
import { ModalFooter } from "../../../../../mantine/components/ModalFooter/ModalFooter";
import { LoadOrError } from "../../../../LoadOrError/LoadOrError";

interface Props {
  dataImportRequestsNames: string[];
  onToggle: () => void;
  onAction: (parameterSetId: string) => void;
}

function ReimportDataImportRequestsModal({
  dataImportRequestsNames,
  onAction,
  onToggle
}: Props) {
  const [selectedParameterSetId, setSelectedParameterSetId] = useState<
    string | null
  >(null);

  const { data, isLoading, error } = useParameterSetCollection();

  const parameterSetOptions = (data || []).map(({ id, name }) => ({
    label: name,
    value: id
  }));

  const handleSendClick = () => {
    if (selectedParameterSetId !== null) {
      onAction(selectedParameterSetId);
    }
  };

  return (
    <Modal
      className="ReimportDataImportRequestsModal"
      opened
      title="Reimport"
      onClose={onToggle}
    >
      <Stack>
        <p>Möchten Sie die folgenden Dateien reimportieren?</p>
        <ul>
          {dataImportRequestsNames.map((name, index) => (
            <li key={`object${index}`}>{name}</li>
          ))}
        </ul>
        <LoadOrError error={error} loading={isLoading}>
          <Select
            data={parameterSetOptions}
            label="Dateiformat"
            required
            onChange={(newValue) => setSelectedParameterSetId(newValue)}
          />
        </LoadOrError>
      </Stack>
      <ModalFooter>
        <Button variant="default" onClick={onToggle}>
          Abbrechen
        </Button>
        <Button
          color="secondary"
          disabled={selectedParameterSetId === null}
          onClick={handleSendClick}
        >
          Einsenden
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { ReimportDataImportRequestsModal };
